import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../api/client';

import tealBack from '../Images/teal_dback.png';
import rypilLo from '../Images/rypilLo.png';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [infoMsg, setInfoMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setErrMsg('');
    setInfoMsg('');
    setSubmitting(true);
    try {
      await apiFetch('/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email: (email || '').trim().toLowerCase() }),
      });
      setInfoMsg('If the email exists, we sent a reset link.');
    } catch (e) {
      console.error(e);
      const msg = e?.data?.error || e?.data?.message || e?.message || 'Please try again.';
      setErrMsg(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${tealBack})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: 'white',
      }}
    >
      {/* Rounded corner frame */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '24px',
          overflow: 'hidden',
          pointerEvents: 'none',
        }}
      />

      {/* Header: rypil Password Reset */}
      <div
        style={{
          position: 'absolute',
          top: '64px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          letterSpacing: '1px',
        }}
      >
        <span style={{ fontSize: 30, fontWeight: 600 }}>
          <span className="rypil-word">rypil</span>{' '}
          <span style={{ fontWeight: 400 }}>Password Reset</span>
        </span>
      </div>

      {/* Center form */}
      <form
        onSubmit={handleResetPassword}
        style={{
          width: 'min(90vw, 540px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 22,
          marginTop: '40px',
        }}
      >
        <input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="login-input"
          style={{
            width: '100%',
            height: 72,
            borderRadius: 20,
            border: '1px solid rgba(255,255,255,0.08)',
            background: 'rgba(255,255,255,0.10)',
            backdropFilter: 'blur(6px)',
            WebkitBackdropFilter: 'blur(6px)',
            color: 'white',
            fontSize: 22,
            padding: '0 28px',
            outline: 'none',
          }}
        />

        {/* helper text aligned to left edge of input */}
        <p
          style={{
            alignSelf: 'flex-start',
            marginTop: -10,
            marginBottom: 10,
            paddingLeft: 0,
            opacity: 0.9,
            fontSize: 16,
          }}
        >
          Enter your email and we’ll send a reset link.
        </p>

        {errMsg && (
          <p style={{ color: '#ffdddd', alignSelf: 'flex-start', marginTop: -4 }}>
            {errMsg}
          </p>
        )}
        {infoMsg && (
          <p style={{ color: '#ddffdd', alignSelf: 'flex-start', marginTop: -4 }}>
            {infoMsg}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting}
          style={{
            width: 320,
            height: 72,
            borderRadius: 20,
            border: 'none',
            cursor: 'pointer',
            fontSize: 24,
            fontWeight: 600,
            color: '#1d1d1d',
            background: '#EBA477',
            boxShadow: '0 2px 10px rgba(0,0,0,0.25)',
            marginTop: 10,
            opacity: submitting ? 0.7 : 1,
          }}
        >
          {submitting ? 'Sending...' : 'Send Reset Link'}
        </button>

        {/* Back to Login */}
        <div style={{ marginTop: 14, fontSize: 18 }}>
          Remember your password?{' '}
          <Link
            to="/login"
            style={{
              color: 'white',
              textDecoration: 'none',
              borderBottom: '2px solid #EBA477',
              paddingBottom: 2,
            }}
          >
            Login
          </Link>
        </div>
      </form>

      {/* Small rypil badge bottom-left */}
      <img
        src={rypilLo}
        alt="rypil mark"
        style={{
          position: 'absolute',
          bottom: 32,
          left: 32,
          height: 56,
          opacity: 0.95,
        }}
      />

      {/* Placeholder color */}
      <style>{`
        .login-input::placeholder { color: rgba(255,255,255,0.75); }
        .login-input:-ms-input-placeholder { color: rgba(255,255,255,0.75); }
        .login-input::-ms-input-placeholder { color: rgba(255,255,255,0.75); }
      `}</style>
    </div>
  );
}

export default ForgotPassword;
